import React from 'react';

const ContentBlock = ({
  image = <img src="https://www.alpresor.se/img/20665.jpg&w=640&h=0" />,

  text = <p>default text</p>,
  cta = <div>cta</div>,
}) => {
  return (
    <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3 grid grid-cols-12 grid-rows-contentBlock grid-cols-block relative mt-8 bg-yellow-15 rounded-lg">
      <div className="col-span-12 relative aspect-4/3">
        {image}
        <div className="absolute bottom-0 m-2 p-2 bg-white rounded grid-cols-subgrid">
          <span className="font-crystalCondensed">Text</span>
        </div>
      </div>
      <div className="col-span-12 grid  place-items-start">
        <div className="col-span-[main]">{text}</div>
      </div>
      <div className="col-span-12">{cta}</div>
    </div>
  );
};

export default ContentBlock;
